const ContactUsIcon = () => {
    return (
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 12">
            <g isolation="isolate">
                <path
                    d="M16,1.5V10.5c0,.83-.67,1.5-1.5,1.5H1.5c-.83,0-1.5-.67-1.5-1.5V1.5C0,.67,.67,0,1.5,0H14.5c.83,0,1.5,.67,1.5,1.5ZM1,1.5v1.29c.68,.58,1.66,1.38,4.71,3.79,.53,.42,1.57,1.43,2.29,1.42,.72,.01,1.77-1,2.29-1.42,3.04-2.42,4.02-3.21,4.71-3.79V1.5c0-.27-.22-.5-.5-.5H1.5c-.27,0-.5,.23-.5,.5ZM15,10.5V4.09c-.71,.58-1.84,1.49-4.08,3.27-.66,.53-1.78,1.64-2.92,1.63-1.14,0-2.27-1.12-2.92-1.63-2.25-1.78-3.37-2.69-4.08-3.27v6.41c0,.28,.23,.5,.5,.5H14.5c.28,0,.5-.22,.5-.5Z"
                    fill="#7f7f7f"/>
            </g>
        </svg>
    );
}
export default ContactUsIcon;
